import {User} from "@app/shared/models";
import {StrainMeasurementStatus} from "@app/strain/registry/models/strain-measurement-status.model";
import {RiskClass} from "@app/strain/config/risk-classes/models/risk-class.model";
import {StrainReportModel} from "@app/strain/common/models/strain-report.model";
import { StrainExecutionMode } from "./enum/strain-execution-mode.enum";
import { StrainMeasurementChartModel } from "./view-measurement-models/strain-measurement-chart.model";

export class StrainMeasurement {
    public id: number;
    public measurementDate: string;
    public minValue: number;
    public maxValue: number;
    public maxDeformationValue: number;
    public measuredBy: User;
    public riskClass: RiskClass;
    public observations: string;
    public status: StrainMeasurementStatus;
    public reports: StrainReportModel[];
    public charts: StrainMeasurementChartModel[];
    public ticketId: number;
    public name: string;
    public measurementMethod: StrainExecutionMode;
    public strainRegisterItemId: number;
    public isInitialMeasurement: boolean;

    constructor(newEntry: any = {}) {
        this.id = newEntry.id;
        this.measurementDate = newEntry.measurementDate;
        this.minValue = newEntry.minValue;
        this.maxValue = newEntry.maxValue;
        this.maxDeformationValue = newEntry.maxDeformationValue;
        this.measuredBy = newEntry.measuredBy ? new User(newEntry.measuredBy) : null;
        this.riskClass = newEntry.riskClass ? new RiskClass(newEntry.riskClass) : null;
        this.observations = newEntry.observations;
        this.status = newEntry.status;
        this.reports = newEntry.reports ? newEntry.reports.map(report => new StrainReportModel(report)) : [];
        this.charts = newEntry.charts ? newEntry.charts.map(chart => new StrainMeasurementChartModel(chart)) : [];
        this.ticketId = newEntry.ticketId || null;
        this.measurementMethod = newEntry.measurementMethod;
        if (newEntry.partNumberName && newEntry.sapFamily && newEntry.processName) {
            this.name = "Report from Entry " + newEntry.strainRegisterItemId + " - " + newEntry.partNumberName +
                "(" + newEntry.sapFamily + ") - " + newEntry.processName;
        } else {
            this.name = "Report_" + newEntry.measurementDate;
        }
        this.strainRegisterItemId = newEntry.strainRegisterItemId;
        this.isInitialMeasurement = newEntry.isInitialMeasurement;
    }
}
